import { getToken, getToken2, getUser } from "../../Utils/Common"
import { getAPICall, postAPICall } from "../axiosMethodCalls"
import Moment from "moment"

//GET
export const getAllSuppliesExpenses = async () => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "supplies_expenses/get_all_supplies_expense",
      {
        requester: getUser(),
        token: getToken(),
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
//GET
export const getAllSuppliesExpensesPotato = async () => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_POTATO +
        "supplies_expenses/get_all_supplies_expense",
      {
        requester: getUser(),
        token: getToken2(),
      },
      "potato"
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// GET SINGLE
export const getSingleSuppliesExpense = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "supplies_expenses/get_supplies_expense",
      {
        requester: getUser(),
        token: getToken(),
        supplies_expense_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// GET ALL BRANCHES
export const getAllBranches = async () => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "branches/get_all_branch",
      {
        requester: getUser(),
        token: getToken(),
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// DELETE
export const deleteSuppliesExpense = async (id) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      supplies_expense_id: id,
    }
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "supplies_expenses/delete",
      payload
    )

    return { response: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const deleteSeAttachment = async (values) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "supplies_expenses/delete_attachment",
      {
        requester: getUser(),
        token: getToken(),
        ...values,
      }
    )
    return { response: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// CREATE
export const createSuppliesExpense = async (newSE, items) => {
  try {
    const formData = new FormData()
    newSE.attachments.map((file) => {
      formData.append(`attachments[]`, file, file.name)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("requisitioner", newSE.requisitioner)
    formData.append("supplier_id", newSE.supplier_id)
    // formData.append("vendor_id", newSE.vendor_id);
    formData.append("branch_id", newSE.branch_id)
    formData.append("forwarder_id", newSE.forwarder_id)
    formData.append("forwarder_contact_person", newSE.forwarder_contact_person)
    formData.append("invoice_no", newSE.invoice_no ? newSE.invoice_no : "")
    formData.append("delivery_address", newSE.delivery_address)
    formData.append("is_save", newSE.is_save)
    formData.append("supplies_expense_date", newSE.supplies_expense_date)
    formData.append("remarks", newSE.remarks || "")
    formData.append("status", newSE.status)
    formData.append("freight_collect", "0")
    formData.append("type", newSE.type)
    formData.append("grand_total", newSE.grand_total)
    formData.append("declared_value", newSE.declared_value)

    items.map((item, index) => {
      formData.append(`names[${index}]`, item.name)
      formData.append(`quantities[${index}]`, item.qty)
      formData.append(`units[${index}]`, item.unit)
      formData.append(`prices[${index}]`, item.price)
      formData.append(`item_remarks[${index}]`, item.remarks)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "supplies_expenses/create",
      formData,
      true
    )

    return response
  } catch (error) {
    return { error: error.response }
  }
}

// UPDATE
export const editSuppliesExpense = async (newSE, items, id) => {
  try {
    const formData = new FormData()
    newSE.attachments.map((file) => {
      formData.append("attachments[]", file, file.name)
      formData.append("attachment_ids[]", null)
    })
    newSE.prev_files.map((file) => {
      formData.append("attachment_ids[]", file.id)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("requisitioner", newSE.requisitioner)
    formData.append("supplies_expense_id", id)
    formData.append("supplier_id", newSE.supplier_id)
    // formData.append("vendor_id", newSE.vendor_id);
    formData.append("branch_id", newSE.branch_id)
    formData.append("forwarder_id", newSE.forwarder_id)
    formData.append("forwarder_contact_person", newSE.forwarder_contact_person)
    formData.append("invoice_no", newSE.invoice_no ? newSE.invoice_no : "")
    formData.append("delivery_address", newSE.delivery_address)
    formData.append("delivery_date", newSE.delivery_date)
    formData.append("is_save", newSE.is_save)
    formData.append("supplies_expense_date", newSE.supplies_expense_date)
    formData.append("remarks", newSE.remarks || "")
    formData.append("status", newSE.status)
    formData.append("freight_collect", "0")
    formData.append("type", newSE.type)
    formData.append("grand_total", newSE.grand_total)
    formData.append("declared_value", newSE.declared_value)

    items.map((item, index) => {
      formData.append(`names[${index}]`, item.name)
      formData.append(`quantities[${index}]`, item.qty)
      formData.append(`units[${index}]`, item.unit)
      formData.append(`prices[${index}]`, item.price)
      formData.append(`item_remarks[${index}]`, item.remarks)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "supplies_expenses/update",
      formData,
      true
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const emailSE = async (id) => {
  // const formData = new FormData();
  // // PO.attachments.forEach((file, index) => {
  // //     formData.append(`attachments[]`, file, file.name);
  // // });
  // formData.append('requester', getUser());
  // formData.append('token', getToken());
  // formData.append('id', id);

  // try {
  //     const response = postAPICall(
  //         process.env.REACT_APP_LINK + "emails/send_so",
  //         formData,
  //         true
  //     );
  //     return response
  // } catch (error) {
  //     return { error: error };
  // }

  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "emails/send_so",
      {
        requester: getUser(),
        token: getToken(),
        id: id,
      }
    )
    return { response: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const receiveSE = async (SE) => {
  const userDetails = {
    requester: getUser(),
    token: getToken(),
  }
  const payload = {
    ...userDetails,
    ...SE,
  }
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "supplies_receives/create",
      {
        ...payload,
      }
    )
    return { response: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// UPDATE
export const approveSuppliesExpense = async (id, status) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      supplies_expense_id: id,
      new_status: status,
    }
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "supplies_expenses/change_status",
      payload
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const searchSE = async (data) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "supplies_expenses/search",
      {
        requester: getUser(),
        token: getToken(),
        se_date_from: data.from ? Moment(data.from).format("YYYY-MM-DD") : "",
        se_date_to: data.to ? Moment(data.to).format("YYYY-MM-DD") : "",
        // branch_id: data.branch_id,
        supplier_id: data.supplier_id,
        vendor_id: data.vendor_id,
        status: data.status,
        order_status: data.order_status,
        limit_by: data.limit_by,
        anything: data.anything,
        page: data.page,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const changeStatus = async (data) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "supplies_expenses/change_status",
      {
        requester: getUser(),
        token: getToken(),
        supplies_expense_id: data.se_id,
        new_status: data.new_status,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const changeMultipleStatusSE = async (ids, status) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "supplies_expenses/multiple_change_status",
      {
        requester: getUser(),
        token: getToken(),
        supplies_expense_id: ids.map((item) => {
          return item.id
        }),
        new_status: status,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const paymentModal = async (
  supplies_expense_id,
  payment,
  balance,
  payee
) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      supplies_expense_id: supplies_expense_id,
      amount: payment.paid_amount ? payment.paid_amount : balance,
      payment_type: payment.payment_type,
      payment_date: payment.payment_date,
      deposit_date: payment.deposit_date,
      remarks: payment.remarks,
      to_account_no: payment.to_account_no,
      to_account_name: payment.to_account_name,
      to_bank_id: payment.to_bank_id,
      to_bank_name: payment.to_bank_name,
      from_bank_id: payment.from_bank_id,
      from_bank_name: payment.bank_name,
      from_account_no: payment.from_account_no,
      from_account_name: payment.from_account_name,
      reference_no: payment.reference_number,
      transaction_no: payment.transaction_no,
      transaction_type: payment.transaction_type,
      payment_description: payment.payment_description,
      transaction_fee: payment.transaction_fee,
      payee: payment.payee ? payment.payee : payee,
      particulars: payment.particulars,
      check_no: payment.cheque_number,
      check_date: payment.cheque_date,
      issued_date: payment.issued_date,
    }
    //
    //
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "supplies_expenses/add_payment",
      payload
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const emailSalesExpense = async (id, file) => {
  const formData = new FormData()
  formData.append("requester", getUser())
  formData.append("token", getToken())
  formData.append("id", id)
  formData.append("attachment", file)

  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "emails/send_supplies_expense",
      formData
    )
    return { response: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
